import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ReplaySubject } from 'rxjs/ReplaySubject';



@Injectable()
export class AgentStoreDetail {
    private cartDetail = new ReplaySubject<any>();
    setAgentDetail(dataValues: any) {
        this.cartDetail.next(dataValues);
    }
    getAgentDetail(): Observable<any> {
        return this.cartDetail.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/agentlocator/agentlocatorservice.ts